// @flow

import React from "react";

import ResultsTable from "../../components/ResultsTable/ResultsTable";
import CorrectnessStats from "../../components/CorrectnessStats/CorrectnessStats";
import CalibrationChart from "../../components/CalibrationChart/CalibrationChart";
import HistoricalErrorPlot from "../../components/HistoricalErrorPlot/HistoricalErrorPlot";

import type { UserTask } from "../../data/user-results";

import * as calibration from "../../utils/calibration";

type TasksResultsProps = {
  tasks: Array<UserTask>,
  hasObjectiveAnswers: boolean
};

const TasksResults = (props: TasksResultsProps) => {
  const tasks = props.tasks.filter(t => !!t.results.length)

  return (
    <div className="TasksResults">
      {props.hasObjectiveAnswers &&
        <div>
          <CorrectnessStats tasks={tasks} />
          <h3>Historical error</h3>
          <p>
            This shows your squared error for the final answer, excluding timeouts.
            Lower numbers are better.
          </p>
          <p>Always guessing 50% would result in a squared error of 0.25.</p>
          <HistoricalErrorPlot tasks={tasks} />
          <h3>Calibration for each time limit</h3>
          <div className="Calibration-Container">
            {tasks[0] && tasks[0].responseTimesInSeconds.map((seconds, resultIndex) => (
              <CalibrationChart
                key={seconds}
                data={calibration.stats(tasks, resultIndex)}
                title={`Judgments within ${seconds} seconds`}
              />
            ))}
          </div>
        </div>
      }
      <h3>Data</h3>
      <ResultsTable data={tasks} hasObjectiveAnswers={props.hasObjectiveAnswers} />
    </div>
  );
};

export default TasksResults;



// WEBPACK FOOTER //
// ./src/components/TasksResults/TasksResults.js